<section class="grid-container">
    <div class="grid-x">
        <div class="medium-12">
            <b>Enter permit application number:</b>
            <input class="no-margin vertical-align-middle" style="width:150px;" [value]="applicationNumber" 
                   (input) ="applicationNumber = $event.target.value" />
            <br />
            <button class="button" name="number" (click)="changeApplicationNumber()">Change Approve Date</button>
            <br />
            {{messageDate}}
        </div>
        <div class="medium-12">
            <b>Enter permit application number:</b>
            <input class="no-margin vertical-align-middle" style="width:150px;" [value] ="changeStateNumber"
                   (input) = "changeStateNumber = $event.target.value" />
            <br />
            <button class="button" name="state" (click)="changeState()">Change State to Pending Denial</button>
            <br />
             {{messageState}}
        </div>
        <div class="medium-6">
            <b>Enter Aging Days of Notifications to Delete:</b>
        </div>
        <div class="medium-6 text-align-left">
            <input class="no-margin vertical-align-middle" style="width:50px;" type="number" min="0" [value]="agingDays" (input)="agingDays = $event.target.value" />
        </div>
         <div class="medium-12">
            <button class="button" name="aging" (click)="deleteNotifications()" disabled>Delete Aged Notifications</button>
            <br />
            {{messageNotifications}}
        </div>
        <div class="medium-6">
            <b>Enter eDiscoveryRequest to test generate:</b>            
        </div>
        <div class="medium-6">
            <input class="no-margin-vertical-align-middle" [(ngModel)]="eDiscoveryRequest" />
        </div>
        <div class="medium-12">
            <button class="button" name="eDiscovery" (click)="testGenerate()">Test Generate eDiscovery Document</button><br />
            {{eDiscoveryResults}}
        </div>
        <div class="medium-6">
            <b>Simulate eDiscovery Scheduled Task</b>
        </div>
        <div class="medium-6">
            <button class="button" name="eDiscoveryTask" (click)="runEDiscovery()">Simulate Task</button>
        </div>
        <div class="medium-6">
            Task Results: {{eDiscoveryTaskResults}}
        </div>
        <div class="medium-12 bold">
            Force Process Queued Document
        </div>
        <div class="medium-6">
            Message ID:
        </div>
        <div class="medium-6">
            <input class="no-margin-vertical-align-middle" [(ngModel)]="messageId" />
        </div>
        <div class="medium-12">
            <button appPreventDoubleClick (throttledClick)="processDocument()" class="button" name="processDocument" [disabled]="messageId == null || messageId.length == 0" >Process Document</button>
        </div>
        <div class="medium-12">
            Status: {{messageStatus}}
        </div>
        <div class="medium-12 bold">
            Test Print Stratigraphic Permit:
        </div>
        <div class="medium-4">Application ID:</div>
        <div class="medium-6">
            <input class="no-margin-vertical-align-middle" [(ngModel)]="stratigraphicPermitId" />
            <a style="display:none" href="" target="_blank" #downloadLink></a>
        </div>
        <div class="medium-2">
            <button class="button" (click)="testPermit()">Test Permit</button>
        </div>
        <div class="medium-6 bold padding-right">Trigger Reminder Generation:</div>
        <div class="medium-2">
            <button class="button" (click)="runReminders()">Run</button>
        </div>
        <div class="medium-4">{{reminderResult}}</div>
    </div>
</section>







